import { MRT_ColumnFiltersState } from "material-react-table";
import { MultiSelectControlledOption } from "components";
import { LOCAL_STORAGE_KEYS } from "consts";
import { safeParseJSON } from "utils";
import { INITIAL_STATUS_OPTIONS } from "../consts";
import { getStatusOptions } from "./helpers";

export const parseFilter = (
  raw: string | null,
): MultiSelectControlledOption[] | null =>
  raw != null ? safeParseJSON<MultiSelectControlledOption[]>(raw, []) : null;

export const readAndParseStoredFilters = () => {
  const storedFiscalYear = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_FISCAL_YEAR,
  );
  const rawCountry = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_COUNTRY,
  );
  const rawSiteIds = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_SITE_IDS,
  );
  const rawUtilityType = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_UTILITY_TYPE,
  );
  const rawBusinessUnit = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_BUSINESS_UNIT,
  );
  const rawCountryRegion = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_COUNTRY_REGION,
  );
  const rawStatus = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_STATUS,
  );

  return {
    storedFiscalYear,
    hasStoredState: !!(
      storedFiscalYear ||
      rawCountry ||
      rawSiteIds ||
      rawUtilityType ||
      rawBusinessUnit ||
      rawCountryRegion ||
      rawStatus
    ),
    parsedCountry: parseFilter(rawCountry),
    parsedSiteIds: parseFilter(rawSiteIds),
    parsedUtilityType: parseFilter(rawUtilityType),
    parsedBusinessUnit: parseFilter(rawBusinessUnit),
    parsedCountryRegion: parseFilter(rawCountryRegion),
    parsedStatus: parseFilter(rawStatus),
  };
};

export const clearStoredFilters = (resetFY: string) => {
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_FISCAL_YEAR,
    resetFY,
  );
  localStorage.setItem(LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_COUNTRY, "[]");
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_UTILITY_TYPE,
    "[]",
  );
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_SITE_IDS,
    "[]",
  );
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_BUSINESS_UNIT,
    "[]",
  );
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_COUNTRY_REGION,
    "[]",
  );
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_STATUS,
    JSON.stringify(getStatusOptions(INITIAL_STATUS_OPTIONS)),
  );
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_COLUMN_FILTERS,
    "[]",
  );
};

export const getStoredColumnFilters = (): MRT_ColumnFiltersState => {
  const raw = localStorage.getItem(
    LOCAL_STORAGE_KEYS.MISSING_DOCUMENTS_PAGE_COLUMN_FILTERS,
  );
  if (Array.isArray(raw)) return raw as MRT_ColumnFiltersState;
  if (typeof raw === "string") {
    return safeParseJSON<MRT_ColumnFiltersState>(raw, []);
  }
  return [];
};
